module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-ttl"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/frontmatter#c1",
      "id": "t1"
    }
  }, [_c('b', [_vm._v("Introduction: Thoughts to Consider")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/frontmatter#c2",
      "id": "t2"
    }
  }, [_vm._v("My Message for the Student")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/frontmatter#c3",
      "id": "t3"
    }
  }, [_vm._v("My Message for the Practitioner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/frontmatter#c4",
      "id": "t4"
    }
  }, [_vm._v("My Message for the Teacher")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/frontmatter#c5",
      "id": "t5"
    }
  }, [_vm._v("My Message for Everyone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter01#c6",
      "id": "t6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 1: Everything in Life Is Energy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter01#c7",
      "id": "t7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Energy in Everyday Terms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter01#c8",
      "id": "t8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Energy of Fear")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter01#c9",
      "id": "t9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Energy of Love")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter01#c10",
      "id": "t10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Become the Divine Circuitry of Reiki")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter01#c11",
      "id": "t11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toroidal Field Diagram")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter01#c12",
      "id": "t12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eight Steps to Build Your Toroidal Field")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter01#c13",
      "id": "t13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intention – The Power of Our Thoughts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter01#c14",
      "id": "t14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five Steps to Guide Your Thoughts and Intent")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter01#c15",
      "id": "t15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four Steps to Guide Your Client’s Thoughts and Intent")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter01#c16",
      "id": "t16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ethics and Permission")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#c17",
      "id": "t17",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 2: Let’s Step into the Classroom")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#c18",
      "id": "t18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prepare Yourself as the Student")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#c19",
      "id": "t19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prepare Yourself as the Teacher")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#c20",
      "id": "t20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prepare the Forms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#c21",
      "id": "t21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prepare the Class Supplies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#c22",
      "id": "t22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prepare the Classroom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#c23",
      "id": "t23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prepare the Students for Class")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#c24",
      "id": "t24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prepare for Continuing Education: Practice and Practice Some More")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c25",
      "id": "t25",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 3: First Degree Reiki Class")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c26",
      "id": "t26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Class Supplies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c27",
      "id": "t27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Handouts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c28",
      "id": "t28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Class Duration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c29",
      "id": "t29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Before Class")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c30",
      "id": "t30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Goals for the Teacher")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c31",
      "id": "t31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Begin the Class")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c32",
      "id": "t32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Brief History of Reiki")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('span', {
    attrs: {
      "href": "#/chapter03#c33",
      "id": "t33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What is Reiki?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c34",
      "id": "t34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reiki Is")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c35",
      "id": "t35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Reiki is Different from Other Healing Modalities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c36",
      "id": "t36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Three Levels of Training")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c37",
      "id": "t37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First Degree and the First Attunement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c38",
      "id": "t38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Second Degree and the Second Attunement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c39",
      "id": "t39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Third Degree and the Third Attunement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c40",
      "id": "t40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Law & Healing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c41",
      "id": "t41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Physical Touch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c42",
      "id": "t42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Medical Diagnoses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c43",
      "id": "t43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anatomy: Front and Back View")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c44",
      "id": "t44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anatomy - Front View")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c45",
      "id": "t45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anatomy - Back View")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c46",
      "id": "t46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hand Positions and Functions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c47",
      "id": "t47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Illustration of Hand Positions - Purpose and Function")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c48",
      "id": "t48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chakras")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c49",
      "id": "t49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chakras - Vibrational Color & Meaning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c50",
      "id": "t50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Density of the Aura")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c51",
      "id": "t51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Illustration of Density of the Aura")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c52",
      "id": "t52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Colors of the Aura Vibrate with Information")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c53",
      "id": "t53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aura - Color Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c54",
      "id": "t54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Giving the Attunement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c55",
      "id": "t55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guided Meditation: Preparing to Receive the Attunement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c56",
      "id": "t56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Practice Session: Goals for the Teacher")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c57",
      "id": "t57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hands-On Practice: Twelve Steps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c58",
      "id": "t58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bring the Class to Good Closure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c59",
      "id": "t59",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 4: Second Degree Reiki Class")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c60",
      "id": "t60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Class Supplies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c61",
      "id": "t61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Handouts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c62",
      "id": "t62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Class Duration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c63",
      "id": "t63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Before Class")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c64",
      "id": "t64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Goals for the Teacher")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c65",
      "id": "t65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Begin the Class")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c66",
      "id": "t66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Agenda for the Day")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c67",
      "id": "t67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quick Review")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c68",
      "id": "t68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Three Degrees")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c69",
      "id": "t69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Energy Reminders")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c70",
      "id": "t70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Permission")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c71",
      "id": "t71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Why Use Symbols?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c72",
      "id": "t72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Exercise to Learn about Symbols")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('span', {
    attrs: {
      "href": "#/chapter04#c73",
      "id": "t73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Three Symbols")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c74",
      "id": "t74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cho Ku Rei")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c75",
      "id": "t75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sei He Kei")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c76",
      "id": "t76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hon Sha Ze Sho Nen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c77",
      "id": "t77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Distant Healing – What is Really Happening?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c78",
      "id": "t78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Distant Healing through Time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c79",
      "id": "t79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Distant Healing through Space")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c80",
      "id": "t80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Giving the Attunement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c81",
      "id": "t81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guided Meditation: Preparing to Receive the Attunement and a Master Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c82",
      "id": "t82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Practice Session: Goals for the Teacher")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c83",
      "id": "t83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reminders for Distant Reiki Across Time and Space")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c84",
      "id": "t84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ten Steps for Distant Reiki")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c85",
      "id": "t85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hands-On Practice Using the Symbols")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c86",
      "id": "t86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bringing the Class to Good Closure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c87",
      "id": "t87",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 5: Third Degree Reiki Class")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c88",
      "id": "t88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Class Supplies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c89",
      "id": "t89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Handouts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c90",
      "id": "t90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Class Duration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c91",
      "id": "t91",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Day One")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c92",
      "id": "t92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Before Class")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c93",
      "id": "t93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Begin the Class")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c94",
      "id": "t94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Review of Day One and Day Two Agenda")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c95",
      "id": "t95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Last Two Symbols")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c96",
      "id": "t96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dai Ko Myo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c97",
      "id": "t97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raku")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c98",
      "id": "t98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advanced Chakra Description")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c99",
      "id": "t99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advanced Chakra Diagram")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c100",
      "id": "t100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Treating Cancer and Other Critical Diseases")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c101",
      "id": "t101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Giving the Attunement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c102",
      "id": "t102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guided Meditation: Preparing to Receive the Attunement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c103",
      "id": "t103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Practice Session: Goals for the Teacher")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c104",
      "id": "t104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bringing Day One to Good Closure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c105",
      "id": "t105",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Day Two")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c106",
      "id": "t106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Begin the Class")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c107",
      "id": "t107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Agenda for Day Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c108",
      "id": "t108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Opening a Private Practice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c109",
      "id": "t109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Becoming the Teacher")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/chapter05#c110",
      "id": "t110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Review of First and Second Degree Content")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c111",
      "id": "t111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teaching the Attunement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c112",
      "id": "t112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Let’s Discuss the Meditation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c113",
      "id": "t113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Attunements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c114",
      "id": "t114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirteen Steps to Give the Attunement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c115",
      "id": "t115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Practice Session")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c116",
      "id": "t116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bringing the Class to Good Closure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter01#c117",
      "id": "t117",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Conclusion: Bringing this Teaching to Good Closure")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter02#c118",
      "id": "t118",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Appendix: Handouts for All Classes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter03#c119",
      "id": "t119",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Recommended Reading")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter04#c120",
      "id": "t120",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Author Biography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f6ec521","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contenttoc.vue
// module id = 63
// module chunks = 0